import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// eslint-disable-next-line import/order
import App from './app/App';
import 'assets/scss/material-dashboard-pro-react.scss?v=1.5.0';
import 'assets/scss/app.scss';
import { get } from 'helpers/apiHelpers';
import { getI18n } from 'react-i18next';
import translationPL from 'locales/pl.json';
import translationEN from 'locales/en.json';
import translationLV from 'locales/lv.json';
import translationRU from 'locales/ru.json';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import { grayColor } from 'assets/jss/material-dashboard-pro-react';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';

import { persistor, store } from './store';
import i18n from './i18n';

posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
  // eslint-disable-next-line camelcase -- FIXME
  cookieless_mode: 'always',
  // eslint-disable-next-line camelcase -- FIXME
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  defaults: '2025-05-24',
  // eslint-disable-next-line camelcase -- FIXME
  person_profiles: 'always',
});

// eslint-disable-next-line @typescript-eslint/no-require-imports, no-undef -- FIXME
require('promise.allsettled').shim();

const DEFAULT_BUNDLES = {
  en: translationEN,
  pl: translationPL,
  lv: translationLV,
  ru: translationRU,
};

const loadLanguage = (lang = null) =>
  // eslint-disable-next-line no-async-promise-executor, promise/param-names -- FIXME
  new Promise(async res => {
    try {
      const bundle = await get(
        '/translations/loader/admin/default',
        {},
        lang ? { forcedLanguage: lang } : {}
      );

      res({
        success: true,
        bundle: {
          ...(DEFAULT_BUNDLES[lang ?? i18n.language ?? 'pl'] ?? {}),
          ...bundle,
        },
      });
    } catch (e) {
      // eslint-disable-next-line no-console -- FIXME
      console.error(e);
      res({ success: false, bundle: {} });
    }
  });

const loadFallbackLanguage = async () => {
  // eslint-disable-next-line prefer-const -- FIXME
  let { success, bundle } = await loadLanguage('pl');

  if (!success) {
    bundle = translationPL;
  }
  i18n.addResourceBundle('pl', 'translation', bundle);
};

loadFallbackLanguage();

const theme = createMuiTheme({
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: '14px',
        backgroundColor: grayColor[18],
        borderRadius: '6px',
        padding: '12px',
      },
      popper: {
        opacity: 'unset',
      },
    },
    MuiTypography: {
      title: {
        color: grayColor[16],
        fontSize: '18px',
      },
    },
    MuiDialogTitle: {
      root: {
        padding: '32px 24px',
      },
    },
  },
});

loadLanguage().then(({ success, bundle: currentLanguageBundle }) => {
  if (success) {
    i18n.addResourceBundle(
      getI18n().language.substr(0, 2),
      'translation',
      currentLanguageBundle
    );
  }

  ReactDOM.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ErrorBoundary>
          <MuiThemeProvider theme={theme}>
            <PostHogProvider client={posthog}>
              <App />
            </PostHogProvider>
          </MuiThemeProvider>
        </ErrorBoundary>
      </PersistGate>
    </Provider>,

    document.getElementById('root')
  );
});
